import React from 'react';
import { getBrandInfo } from '~/utils/brand';

interface AccountBannerProps {
    bannerUrl?: string;
}

/**
 * 平台登录注册页左侧 Banner
 */
const AccountBanner: React.FC<AccountBannerProps> = (props) => {
    const { bannerUrl } = props;

    return (
        <div
            className="fx-account-banner"
            style={{
                backgroundImage: `url(${getBrandInfo({ loginBanner: bannerUrl }).loginBanner})`
            }}
        />
    );
};

export default AccountBanner;
